import React, { useCallback, useEffect } from 'react';
import { Icon, Stack, Typography } from '@worthy-npm/worthy-common-ui-components';
import _, { debounce } from 'lodash';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { selectType, updateType } from '../../slices/submitSlice';
import { ItemTypes, ItemTypesPlural } from '../../data/ItemDetails';
import GA from '../../data/GA';
import { StepProps } from '../steps/common';
import { Step, StepContainer, StepGridContainer } from '../../styles/common';
import StepTitle from '../stepTitle';
import { parametrize } from '../../lib/commonUtils';
import { DEBOUNCE_DELAY, DEBOUNCE_OPTIONS } from '../../data/constants';
import { links, LinksObject } from './common';
import { StyledButton, StyledList } from '../common/ButtonsList';
import StyledInfoAlert from '../common/StyledInfoAlert';

const BraceletIcon = Icon.createSvgIcon(
  <svg width="24" height="24" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_3420_60958)">
      <path
        d="M32 16.6667C32 10.2344 25.7156 5 18 5C10.2844 5 4 10.2344 4 16.6667C4 20.4933 6.23222 23.8844 9.65444 26.0156C9.65444 26.0467 9.64667 26.0778 9.64667 26.1089C9.64667 27.8278 11.0389 29.22 12.7578 29.22C13.3333 29.22 13.8622 29.0489 14.3289 28.7767C14.8422 30.3244 16.2889 31.4444 18 31.4444C19.7111 31.4444 21.1578 30.3167 21.6711 28.7767C22.13 29.0489 22.6667 29.22 23.2422 29.22C24.9611 29.22 26.3533 27.8278 26.3533 26.1089C26.3533 26.0778 26.3456 26.0467 26.3456 26.0156C29.7678 23.8844 32 20.4933 32 16.6667ZM23.2422 27.6567C23.1022 27.6567 22.97 27.6333 22.8378 27.5944C22.5033 27.5011 22.2156 27.3067 22.0056 27.0344C21.85 26.8244 21.7411 26.5833 21.7022 26.3111C21.6944 26.2411 21.6789 26.1711 21.6789 26.0933C21.6789 25.2378 22.3789 24.5378 23.2344 24.5378C23.7789 24.5378 24.2533 24.8178 24.5333 25.2456C24.6733 25.4633 24.7589 25.72 24.7822 25.9922C24.7822 26.0311 24.79 26.0622 24.79 26.0933C24.79 26.42 24.6889 26.7233 24.5178 26.9722C24.2378 27.3844 23.7711 27.6489 23.2344 27.6489L23.2422 27.6567ZM18 29.8889C16.9267 29.8889 16.0322 29.1578 15.76 28.17C15.7056 27.9756 15.6667 27.7733 15.6667 27.5556C15.6667 27.4933 15.6822 27.4389 15.6822 27.3767C15.7056 27.1122 15.76 26.8556 15.8611 26.6144C16.2267 25.7978 17.0433 25.2222 17.9922 25.2222C18.9411 25.2222 19.7656 25.7978 20.1233 26.6144C20.2244 26.8478 20.2867 27.1044 20.3022 27.3767C20.3022 27.4389 20.3178 27.4933 20.3178 27.5556C20.3178 27.7656 20.2789 27.9756 20.2244 28.17C19.9522 29.1578 19.0578 29.8889 17.9844 29.8889H18ZM11.4744 26.98C11.3033 26.7311 11.2022 26.4278 11.2022 26.1011C11.2022 26.0622 11.21 26.0311 11.21 26C11.2256 25.7278 11.3111 25.4711 11.4589 25.2533C11.7389 24.8333 12.2133 24.5456 12.7578 24.5456C13.6133 24.5456 14.3133 25.2456 14.3133 26.1011C14.3133 26.1789 14.2978 26.2489 14.29 26.3189C14.2511 26.5911 14.15 26.8322 13.9867 27.0422C13.7844 27.3144 13.4889 27.5089 13.1544 27.6022C13.0222 27.6333 12.89 27.6644 12.75 27.6644C12.2211 27.6644 11.7467 27.3922 11.4667 26.9878L11.4744 26.98ZM23.2422 22.99C22.0678 22.99 21.0489 23.6511 20.52 24.6233C19.8356 24.04 18.9644 23.6667 17.9922 23.6667C17.02 23.6667 16.1489 24.0322 15.4644 24.6233C14.9356 23.6589 13.9244 22.99 12.7422 22.99C11.56 22.99 10.65 23.5889 10.0978 24.4833C7.31333 22.6244 5.54 19.8167 5.54 16.6667C5.55556 11.09 11.14 6.55556 18 6.55556C24.86 6.55556 30.4444 11.09 30.4444 16.6667C30.4444 19.8089 28.6633 22.6244 25.8867 24.4833C25.3422 23.5967 24.3622 22.99 23.2422 22.99Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_3420_60958">
        <rect width="28" height="26.4444" fill="white" transform="translate(4 5)" />
      </clipPath>
    </defs>
  </svg>,
  'Bracelet',
);
const EarringsIcon = Icon.createSvgIcon(
  <svg width="24" height="24" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_3420_60961)">
      <path
        d="M14 1C12.232 1 10.8 2.432 10.8 4.2V10.712C9.424 11.072 8.4 12.312 8.4 13.8C8.4 14.624 8.72 15.368 9.232 15.936C7.328 16.832 6 18.76 6 21C6 24.088 8.512 26.6 11.6 26.6C14.688 26.6 17.2 24.088 17.2 21C17.2 18.76 15.872 16.824 13.968 15.936C14.48 15.368 14.8 14.624 14.8 13.8C14.8 12.312 13.776 11.072 12.4 10.712V4.2C12.4 3.32 13.12 2.6 14 2.6C14.88 2.6 15.6 3.32 15.6 4.2V6.152C15.6 6.592 15.96 6.952 16.4 6.952C16.84 6.952 17.2 6.592 17.2 6.152V4.2C17.2 2.432 15.768 1 14 1V1ZM15.6 21C15.6 23.208 13.808 25 11.6 25C9.392 25 7.6 23.208 7.6 21C7.6 18.792 9.392 17 11.6 17C13.808 17 15.6 18.792 15.6 21ZM13.2 13.8C13.2 14.68 12.48 15.4 11.6 15.4C10.72 15.4 10 14.68 10 13.8C10 12.92 10.72 12.2 11.6 12.2C12.48 12.2 13.2 12.92 13.2 13.8Z"
        fill="currentColor"
      />
      <path
        d="M29.1998 14.952C29.6398 14.952 29.9998 14.592 29.9998 14.152V12.2C29.9998 10.432 28.5678 9 26.7998 9C25.0318 9 23.5998 10.432 23.5998 12.2V18.712C22.2238 19.072 21.1998 20.312 21.1998 21.8C21.1998 22.624 21.5198 23.368 22.0318 23.936C20.1278 24.832 18.7998 26.76 18.7998 29C18.7998 32.088 21.3118 34.6 24.3998 34.6C27.4878 34.6 29.9998 32.088 29.9998 29C29.9998 26.76 28.6718 24.824 26.7678 23.936C27.2798 23.368 27.5998 22.624 27.5998 21.8C27.5998 20.312 26.5758 19.072 25.1998 18.712V12.2C25.1998 11.32 25.9198 10.6 26.7998 10.6C27.6798 10.6 28.3998 11.32 28.3998 12.2V14.152C28.3998 14.592 28.7598 14.952 29.1998 14.952ZM28.3998 29C28.3998 31.208 26.6078 33 24.3998 33C22.1918 33 20.3998 31.208 20.3998 29C20.3998 26.792 22.1918 25 24.3998 25C26.6078 25 28.3998 26.792 28.3998 29ZM25.9998 21.8C25.9998 22.68 25.2798 23.4 24.3998 23.4C23.5198 23.4 22.7998 22.68 22.7998 21.8C22.7998 20.92 23.5198 20.2 24.3998 20.2C25.2798 20.2 25.9998 20.92 25.9998 21.8Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_3420_60961">
        <rect width="24" height="33.6" fill="white" transform="translate(6 1)" />
      </clipPath>
    </defs>
  </svg>,
  'Earrings',
);
const LooseDiamondIcon = Icon.createSvgIcon(
  <svg width="24" height="24" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M34.2787 11.9084L28.7243 4.63686C28.418 4.24185 27.9424 4 27.4426 4H8.16744C7.66763 4 7.19199 4.23378 6.88566 4.63686L1.33126 11.9084C0.855631 12.5291 0.895939 13.3997 1.428 13.9802L16.624 30.5063C16.9303 30.8368 17.3576 31.0303 17.809 31.0303C18.2605 31.0303 18.6877 30.8368 18.9941 30.5063L34.182 13.9802C34.7141 13.3997 34.7544 12.5372 34.2787 11.9084V11.9084ZM20.1146 5.61231L23.7423 13.3594C19.9453 13.6093 16.1322 13.6174 12.3353 13.3836L15.6324 5.61231H20.1066H20.1146ZM12.6577 15.0121C14.3909 15.1088 16.1242 15.1733 17.8574 15.1733C19.7116 15.1733 21.5738 15.1007 23.4279 14.9879L17.8413 28.4345L12.6577 15.0121ZM8.16744 5.61231H13.8831L10.6343 13.2546C8.74787 13.1015 6.86953 12.8999 4.9912 12.6258L3.04031 12.3356L8.16744 5.61231ZM4.74935 14.222C6.78892 14.5203 8.82849 14.746 10.8761 14.8992L15.5196 26.9351L3.69329 14.0608L4.74935 14.214V14.222ZM20.3 26.7013L25.2176 14.8669C27.2652 14.6977 29.3128 14.4719 31.3524 14.1656L31.9006 14.085L20.3 26.7093V26.7013ZM31.1106 12.5694C29.2322 12.8516 27.3458 13.0692 25.4594 13.2305L21.8882 5.61231H27.4426L32.5778 12.3437L31.1106 12.5694Z"
      fill="currentColor"
    />
  </svg>,
  'LooseDiamond',
);
const WatchIcon = Icon.createSvgIcon(
  <svg width="24" height="24" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_3420_60959)">
      <path
        d="M20.4 29.6001H15.6C10.304 29.6001 6 25.2961 6 20.0001V15.2001C6 9.9041 10.304 5.6001 15.6 5.6001H20.4C25.696 5.6001 30 9.9041 30 15.2001V20.0001C30 25.2961 25.696 29.6001 20.4 29.6001ZM15.6 7.2001C11.192 7.2001 7.6 10.7921 7.6 15.2001V20.0001C7.6 24.4081 11.192 28.0001 15.6 28.0001H20.4C24.808 28.0001 28.4 24.4081 28.4 20.0001V15.2001C28.4 10.7921 24.808 7.2001 20.4 7.2001H15.6Z"
        fill="currentColor"
      />
      <path
        d="M24.4162 8C23.9762 8 23.6162 7.64 23.6162 7.2V0.8C23.6162 0.36 23.9762 0 24.4162 0C24.8562 0 25.2162 0.36 25.2162 0.8V7.2C25.2162 7.64 24.8562 8 24.4162 8Z"
        fill="currentColor"
      />
      <path
        d="M11.6721 8C11.2321 8 10.8721 7.64 10.8721 7.2V0.8C10.8721 0.36 11.2321 0 11.6721 0C12.1121 0 12.4721 0.36 12.4721 0.8V7.2C12.4721 7.64 12.1121 8 11.6721 8Z"
        fill="currentColor"
      />
      <path
        d="M24.4162 35.5039C23.9762 35.5039 23.6162 35.1439 23.6162 34.7039V28.3039C23.6162 27.8639 23.9762 27.5039 24.4162 27.5039C24.8562 27.5039 25.2162 27.8639 25.2162 28.3039V34.7039C25.2162 35.1439 24.8562 35.5039 24.4162 35.5039Z"
        fill="currentColor"
      />
      <path
        d="M11.6721 35.5039C11.2321 35.5039 10.8721 35.1439 10.8721 34.7039V28.3039C10.8721 27.8639 11.2321 27.5039 11.6721 27.5039C12.1121 27.5039 12.4721 27.8639 12.4721 28.3039V34.7039C12.4721 35.1439 12.1121 35.5039 11.6721 35.5039Z"
        fill="currentColor"
      />
      <path
        d="M22.7602 21.8959C22.6162 21.8959 22.4722 21.8559 22.3362 21.7759L17.5762 18.8159C17.3442 18.6719 17.2002 18.4159 17.2002 18.1359V10.6799C17.2002 10.2399 17.5602 9.87988 18.0002 9.87988C18.4402 9.87988 18.8002 10.2399 18.8002 10.6799V17.6879L23.1842 20.4159C23.5602 20.6479 23.6722 21.1439 23.4402 21.5199C23.2882 21.7599 23.0242 21.8959 22.7602 21.8959V21.8959Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_3420_60959">
        <rect width="24" height="35.504" fill="white" transform="translate(6)" />
      </clipPath>
    </defs>
  </svg>,
  'Watch',
);
const NecklaceIcon = Icon.createSvgIcon(
  <svg width="24" height="24" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_3420_60957)">
      <path
        d="M31.2 4.8C31.2 4.36 30.84 4 30.4 4C29.96 4 29.6 4.36 29.6 4.8C29.6 9.632 25.72 16.648 20.488 18.648C19.976 17.56 18.88 16.8 17.6 16.8C16.32 16.8 15.224 17.56 14.712 18.648C9.48 16.648 5.6 9.632 5.6 4.8C5.6 4.36 5.24 4 4.8 4C4.36 4 4 4.36 4 4.8C4 10.2 8.304 18.104 14.424 20.248C14.48 20.968 14.784 21.624 15.24 22.128C13.328 23.024 12 24.952 12 27.2C12 30.288 14.512 32.8 17.6 32.8C20.688 32.8 23.2 30.288 23.2 27.2C23.2 24.952 21.872 23.024 19.96 22.128C20.416 21.616 20.72 20.968 20.776 20.248C26.896 18.112 31.2 10.2 31.2 4.8ZM21.6 27.2C21.6 29.408 19.808 31.2 17.6 31.2C15.392 31.2 13.6 29.408 13.6 27.2C13.6 24.992 15.392 23.2 17.6 23.2C19.808 23.2 21.6 24.992 21.6 27.2ZM16.16 20.688C16.056 20.48 16 20.248 16 20C16 19.656 16.112 19.344 16.288 19.088C16.576 18.672 17.056 18.4 17.6 18.4C18.144 18.4 18.616 18.672 18.912 19.088C19.096 19.344 19.2 19.664 19.2 20C19.2 20.248 19.136 20.48 19.04 20.688C18.784 21.224 18.24 21.6 17.6 21.6C16.96 21.6 16.424 21.224 16.16 20.688Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_3420_60957">
        <rect width="27.2" height="28.8" fill="white" transform="translate(4 4)" />
      </clipPath>
    </defs>
  </svg>,
  'Necklace',
);
const RingIcon = Icon.createSvgIcon(
  <svg width="24" height="24" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21.1209 10.4477C22.1439 9.56861 22.7992 8.26591 22.7992 6.80338C22.7992 4.15003 20.6414 1.99219 17.988 1.99219C15.3347 1.99219 13.1768 4.15003 13.1768 6.80338C13.1768 8.25792 13.8322 9.56062 14.8551 10.4477C9.76424 11.8303 6 16.4817 6 22.0122C6 28.6216 11.3786 34.0002 17.988 34.0002C24.5974 34.0002 29.976 28.6216 29.976 22.0122C29.976 16.4897 26.2118 11.8383 21.1209 10.4557V10.4477ZM14.7752 6.80338C14.7752 5.02915 16.2138 3.59059 17.988 3.59059C19.7622 3.59059 21.2008 5.02915 21.2008 6.80338C21.2008 8.5776 19.7622 10.0162 17.988 10.0162C16.2138 10.0162 14.7752 8.5776 14.7752 6.80338ZM17.988 32.3938C12.2577 32.3938 7.5984 27.7344 7.5984 22.0042C7.5984 16.2739 12.2577 11.6226 17.988 11.6226C23.7183 11.6226 28.3776 16.2819 28.3776 22.0122C28.3776 27.7424 23.7183 32.4018 17.988 32.4018V32.3938Z"
      fill="currentColor"
    />
  </svg>,
  'Ring',
);
export const Types = [
  {
    text: ItemTypes.Ring,
    img: RingIcon,
    code: ItemTypes.Ring,
  },

  {
    text: ItemTypes.LooseDiamond,
    img: LooseDiamondIcon,
    code: ItemTypes.LooseDiamond,
  },
  {
    text: ItemTypes.Watch,
    img: WatchIcon,
    code: ItemTypes.Watch,
  },
  {
    text: ItemTypes.Necklace,
    img: NecklaceIcon,
    code: ItemTypes.Necklace,
  },
  {
    text: ItemTypes.Bracelet,
    img: BraceletIcon,
    code: ItemTypes.Bracelet,
  },
  {
    text: ItemTypes.Earrings,
    img: EarringsIcon,
    code: ItemTypesPlural.Earrings,
  },
];

function StepSelectItemType({
  title,
  stepCaption,
  props,
}: Omit<StepProps, 'next' | 'prev'>) {
  const dispatch = useAppDispatch();
  const itemType = useAppSelector(selectType);
  const navigate = useNavigate();

  useEffect(() => {
    GA.typeSelectionView();
  }, []);

  const debouncedClickHandler = useCallback(
    debounce((itemCode: string) => {
      GA.submitItemType(itemCode);
      dispatch(updateType(itemCode));
      const path = links[_.camelCase(itemCode) as keyof LinksObject];
      navigate(path);
    }, DEBOUNCE_DELAY, DEBOUNCE_OPTIONS),
    [dispatch, navigate],
  );

  return (
    <StepContainer
      data-automation="type-select-step"
      data-testid="type-select-step"
      style={{ height: '100%', overflow: 'auto' }}
    >
      <Step>
        <StepTitle
          prev={false}
          stepCaption={stepCaption}
          stepTitle={title || 'What type of jewelry do you have?'}
          stepNotice="Select an option below"
          optionalProps={props || {}}
        />

        <StepGridContainer>
          <StyledList>
            {Types.map((item) => (
              <StyledButton
                data-automation={`type-select-step-item-${parametrize(item.code)}`}
                key={item.code}
                selected={itemType === item.code}
                onClick={() => {
                  debouncedClickHandler(item.code);
                }}
              >
                <Stack direction="row" gap={1} alignItems="center">
                  <item.img sx={{ fontSize: 32 }} />
                  <Typography variant="body1" textTransform="capitalize">
                    {item.code}
                  </Typography>
                </Stack>
              </StyledButton>
            ))}
          </StyledList>

          <StyledInfoAlert sx={{ marginTop: 3 }}>
            You will be able to add more jewelry later in the process.
          </StyledInfoAlert>
        </StepGridContainer>
      </Step>
    </StepContainer>
  );
}

export default StepSelectItemType;
